// ---- Tarification : base hors taxes ----
// Le HT est la valeur tarifaire de référence. Le TTC est calculé à partir de
// VAT_RATE (taux normal de TVA en France métropolitaine, modifiable ici).
export const VAT_RATE = 0.2;

export function formatEUR(n) {
  const s = Number.isInteger(n) ? String(n) : n.toFixed(2).replace(".", ",");
  return `${s}\u00A0€`;
}

export function ttc(ht) {
  return Math.round(ht * (1 + VAT_RATE) * 100) / 100;
}

export const DEREF_PRICE_HT = 100;

// Mention tarifaire générale (page Services et mentions légales).
export const PRICING_NOTICE_FR =
  "Les tarifs sont exprimés en euros hors taxes. La TVA est facturée en sus au taux applicable au jour de la facturation. Les conditions contractuelles applicables sont précisées avant toute prestation.";
export const PRICING_NOTICE_EN =
  "Prices are expressed in euros excluding tax. VAT is invoiced in addition at the rate applicable on the invoicing date. The applicable contractual conditions are specified before any service.";

// ---- Future structure porteuse de l'activité (facturation) ----
// À compléter lorsque la structure juridique porteuse sera définitivement
// connue. Tant que `enabled` vaut false, aucune de ces informations ne doit
// apparaître publiquement sur le site.
export const BILLING_ENTITY = {
  enabled: false,
  raisonSociale: "",
  formeJuridique: "",
  adresse: "",
  siret: "",
  tvaIntracommunautaire: "",
  contactAdministratif: "",
  mentionCape: "",
};
